type Props = {
  height?: number;
  stroke: string;
  width?: number;
};

export default function ProductTagIcon({
  stroke = 'black',
  width = 32,
  height = 32
}: Props) {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.7979 4.227C16.2296 3.79528 16.8414 3.59555 17.4447 3.68939L25.4664 4.93721C26.2892 5.06521 26.9348 5.71073 27.0628 6.53355L28.3106 14.5552C28.4044 15.1585 28.2047 15.7704 27.773 16.2021L16.2021 27.7729C15.455 28.5201 14.2437 28.5201 13.4965 27.773L4.22703 18.5034C3.47991 17.7563 3.47991 16.545 4.22703 15.7979L15.7979 4.227Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <circle
          cx="20"
          cy="12.1618"
          r="2"
          transform="rotate(45 20 12.1618)"
          stroke={stroke}
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
